import React from "react";
import { fmtAmount } from "./bookingPricing";

interface Props {
  amount: number;
  currency?: string;
  amountLabel: string;
  ctaLabel: string;
  ctaDisabled: boolean;
  submitting: boolean;
  onContinue: () => void;
  lang: string;
}

const MobileBookingBar: React.FC<Props> = ({
  amount, currency, amountLabel, ctaLabel, ctaDisabled, submitting, onContinue, lang,
}) => (
  <div className="pab-mobile-bar">
    <div className="pab-mobile-bar__info">
      <span className="pab-mobile-bar__label">{amountLabel}</span>
      <span className="pab-mobile-bar__amount">{amount > 0 ? fmtAmount(amount, currency) : "—"}</span>
    </div>
    <button
      type="button"
      className="pab-cta-btn pab-mobile-bar__btn"
      disabled={ctaDisabled || submitting}
      onClick={onContinue}
    >
      {submitting ? (lang === "en" ? "Sending…" : "Slanje…") : ctaLabel}
    </button>
  </div>
);

export default MobileBookingBar;
